import React, { useEffect, useCallback, useState } from "react";
import { Grid, Row, Col, Spin } from "antd";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import styles from "./StakingSelect.module.css";
import * as Service from "../core/Service";

const { useBreakpoint } = Grid;

const StakingSelect = () => {
  const history = useHistory();
  const breakpoint = useBreakpoint();

  const [loading, setLoading] = useState(true);
  const [nftList, setNftList] = useState([]);
  const [selectedNft, setSelectedNft] = useState({});

  const { IS_TESTNET } = useSelector(
    (state) => state.app.config
  );

  const wallet_address = localStorage.getItem("wallet_address");

  const getNfts = useCallback(async () => {
    setLoading(true);

    try {
      const resp = await Service.callServer("get", "/api/nft", {
        wallet_address,
      });
      setNftList(resp?.data?.ownedNfts || []);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [wallet_address]);

  useEffect(() => {
    if (_.isUndefined(IS_TESTNET)) {
      return;
    }
    getNfts();
  }, [IS_TESTNET, getNfts]);

  return (
    <Spin spinning={loading}>
      <AppLayout>
        <div className="boxContainer">
          <div className={styles.stakingSelectContainer}>
            <Row justify="left" className={styles.ft_44_900}>
              Select Genesis to store
            </Row>

            <Row
              gutter={[breakpoint?.md ? 20 : 8, breakpoint?.md ? 20 : 8]}
              style={{ marginTop: 20 }}
            >
              {_.map(nftList, (obj) => {
                return (
                  <Col span={breakpoint?.md ? 6 : 12} key={obj?.tokenId}>
                    <div
                      onClick={() => {
                        setSelectedNft(obj);
                      }}
                      className={`${styles.nftGradientBorder} ${
                        selectedNft?.tokenId === obj?.tokenId &&
                        styles.selectedNftGradientBorder
                      }`}
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <img
                        src={
                          obj?.image?.originalUrl ||
                          "/images/staking/sample_nft.png"
                        }
                        alt=""
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: 16,
                        }}
                      />
                    </div>
                    <Row
                      justify="center"
                      style={{ marginTop: 8 }}
                      className={styles.ft_24_500}
                    >
                      {`#${String(obj?.tokenId).padStart(3, "0")}`}
                    </Row>
                  </Col>
                );
              })}
            </Row>

            <Row
              justify="center"
              gutter={[20, 20]}
              style={{ marginTop: 40, marginBottom: 60 }}
            >
              <Col span={breakpoint?.md ? "" : 24}>
                <div
                  className={`${styles.button}  ${
                    !selectedNft?.tokenId && styles.buttonDisabled
                  }`}
                  onClick={() => {
                    if (!selectedNft?.tokenId) {
                      return;
                    }

                    history.push("/storing/confirm", {
                      selectedNft,
                    });
                  }}
                >
                  <div className={styles.buttonText}>Confirm</div>
                </div>
              </Col>
              <Col span={breakpoint?.md ? "" : 24}>
                <div
                  className={styles.outlineBtn}
                  onClick={() => {
                    history.push("/storing");
                  }}
                >
                  <div className={styles.outlineBtnText}>Cancel & Back</div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </AppLayout>
    </Spin>
  );
};

export default StakingSelect;
